import Lottie from "react-lottie";
import clockRunning from "../../../../assets/setting-job/clock-running.json";
import errorJson from "../../../../assets/setting-job/error2.json";
import successJson from "../../../../assets/setting-job/success.json";
import { SettingJobStatusEnum } from "src/entity/settings/job";
import React from "react";

interface AnimationRenderProps {
  status: SettingJobStatusEnum;
}

const AnimationRender: React.FC<AnimationRenderProps> = ({ status }) => {
  const defaultOptions = {
    loop: status === SettingJobStatusEnum.RUNNING ? true : false,
    autoplay: true,
    animationData:
      status === SettingJobStatusEnum.RUNNING ? clockRunning : status === SettingJobStatusEnum.SUCCESS ? successJson : errorJson,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div>
      <Lottie options={defaultOptions} height={35} width={35} />
    </div>
  );
};

export default AnimationRender;
